import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export type ExtendedTFunction = (
	key: string | string[],
	options?: import('i18next').TOptions,
) => string;

function useI18n() {
	const { t, i18n } = useTranslation();

	return {
		t,
		i18n,
		language: i18n.language,
	};
}

export default useI18n;
